
import type { PropType } from 'vue'
import { defineComponent } from 'vue'

export default defineComponent({
    props: {
        color: {
            type: String as PropType<'gray'>,
            default: 'gray'
        },
        disabled: {
            type: Boolean,
            default: false,
        }
    }
})
